<style scoped lang="scss">
@import "@/assets/scss/global.scss";

.glaze-h1 {
    font-size: 24px;
    font-weight: 300;
    z-index: 2;
    letter-spacing: .96px;
    min-width: 323px;
    color: #022266;
    line-height: 48px;
    font-size: 32px;
}

.title-bar {
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;

    font-size: 24pt;
    font-weight: 300;
    line-height: 47px;
    z-index: 2;
    letter-spacing: 0.96px;
    min-width: 323px;
    color: $glaze-blue;

    @media (max-width: 323px) {
        min-width: 296px;
        font-size: 36px;
    }
}

.header-background {
    border-top: 1px solid #e7e7e7;
    background-color: #fafafa;
    padding-top: 42px;
    padding-bottom: 42px;
    border-bottom: 1px solid #e7e7e7;
}

.search-bar-container {
    width: 400px;
    max-width: 400px;
}

.search-bar {
    width: 400px;
}

.collection-selector-wrapper {
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    height: 46px;
}

.glaze-content-wrapper {
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;
}

.content-wrapper {
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 32px;
    position: relative;
}

.intro-statement {
    max-width: 614px;
}

.whale-image {
    height: 208px;
    position: absolute;
    top: -33px;
    right: -54px;
}

.illustration-info {
    cursor: pointer;
    font-size: 80%;
    padding-right: 18px;
}

.whale-image-subtext {
    position: absolute;
    right: -16px;
    top: 191px;
}

.separator-50 {
    height: 50px;
}

.h-border {
    opacity: .2;
    border: 1px solid #979797;
}

.about-card-row {
    height: 300px;
}

.about-card {
    text-align: center;
    position: relative;
}

.cat-image {
    position: absolute;
    top: -39px;
    left: 53px;
    height: 259px;
}

.globe-image {
    position: absolute;
    top: 24px;
    left: 106px;
    height: 128px;
}

.trophy-image {
    position: absolute;
    top: 14px;
    left: 95px;
    height: 150px;
}

.about-card-content {
    position: absolute;
    bottom: 0;
    height: 140px;
    width: 100%;
}

.about-card-title {
    color: #474747;
    font-weight: 500;
    letter-spacing: .69px;
    margin-bottom: 16px;
}

.about-column {
    display: none;
}

.separator-40 {
    height: 40px;
}

.separator-90 {
    height: 90px;
}
</style>

<template>
    <div class="about-wrapper">
        <div class="header-background">
            <v-layout class="title-bar" row>
                <v-flex class="glaze-h1">
                    About Us
                </v-flex>
            </v-layout>
        </div>
        <div class="content-wrapper">
            <div class="intro-statement">
                We have a passion for making the internet beautiful. Founded in 2018, Glaze is a platform that
                democratizes access to high quality illustrations. <br><br>
                Prior to creating Glaze, every time we were looking for quality royalty-free illustrations, we kept
                running into websites that offer clip art or outdated styles that didn’t fit the level of quality we
                were looking for.<br><br>
                At Glaze, quality comes first. Our library is curated by expert moderators that
                account for changing visual styles, high quality craftsmanship, and strong aesthetic value. <br></div>
            <div class="whale-image-container"><img src="@/assets/illustrations/whale.png" alt="" class="whale-image">
                <div class="illustration-info whale-image-subtext">
                    Illustrated by Rudityas<br>source: Glaze
                    <i aria-hidden="true" class="v-icon material-icons theme--light">open_in_new</i>
                </div>
            </div>
            <div class="separator-50 optional-separator"></div>
            <div class="h-border"></div>
            <div class="layout about-card-row row">
                <div class="flex about-card"><img src="@/assets/illustrations/cat.png" alt="" class="cat-image">
                    <div class="about-card-content">
                        <div class="about-card-title">
                            FREE-TO-USE
                        </div>
                        <div class="about-card-subtitle">
                            All of our images are free to use <br> with attribution.
                        </div>
                    </div>
                </div>
                <div class="flex about-card text-xs-center"><img src="@/assets/illustrations/trophy.png" alt=""
                        class="trophy-image">
                    <div class="about-card-content">
                        <div class="about-card-title">
                            PREMIUM QUALITY
                        </div>
                        <div class="about-card-subtitle">
                            Curated by expert moderators that <br>
                            account for changing visual styles
                        </div>
                    </div>
                </div>
                <div class="flex about-card"><img src="@/assets/illustrations/globe.png" alt="" class="globe-image">
                    <div class="about-card-content">
                        <div class="about-card-title">
                            WORLD LIBRARY
                        </div>
                        <div class="about-card-subtitle">
                            Glaze is used by educational <br> institutions, non-profits,
                            startups, <br> and fortune 500 companies
                        </div>
                    </div>
                </div>
            </div>
            <div class="layout about-column column">
                <div class="separator-30"></div>
                <div class="section-title">
                    FREE-TO-USE
                </div>
                <div class="separator-10"></div>
                <div class="section-subtitle">
                    All of our images are free to use with attribution.
                </div>
                <div class="separator-10"></div>
                <div class="section-title">
                    PREMIUM QUALITY
                </div>
                <div class="separator-10"></div>
                <div class="section-subtitle">
                    Curated by expert moderators that
                    account for changing visual styles
                </div>
                <div class="separator-10"></div>
                <div class="section-title">
                    WORLD LIBRARY
                </div>
                <div class="separator-10"></div>
                <div class="section-subtitle">
                    Glaze is used by educational institutions, non-profits, startups, and fortune 500 companies
                </div>
            </div>
            <div class="h-border"></div>
            <div class="separator-40"></div>
            Glazestock.com is a part of © Wavy Corporation Inc, a Delaware Corporation.
        </div>
    </div>


</template>

<script>
export default {
    mounted: function () {
    },
    data() {
        return {};
    }
    // methods: {},
    // watch: {},
    // computed: {},
    // created() {},
    // components: {}
};
</script>
